import { Component, OnInit } from "@angular/core";

@Component({
    selector: 'app-habilitacao-pesquisa',
    templateUrl: 'habilitacao-pesquisa.component.html',
    standalone: false
})
export class HabilitacaoPesquisaComponent implements OnInit{
    ngOnInit(): void {

    }
}
